export default {"src":"/_next/static/media/agi.db18f467.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};